/* eslint-disable */
import { AUTH_LOGIN, AUTH_LOGIN_COMPLETE, AUTH_LOGIN_ERROR, AUTH_LOGIN_SUCCESS } from '../Auth.types';

/**
 * Attempt to login a user and fire the appropriate actions
 * @param {AuthServiceLoginWithUsernameAndPasswordDto} dto The required params to login a user
 * @returns {ActionCreator<FromPromise<AuthEntity, Error, {}, AUTH_LOGIN, AUTH_LOGIN_COMPLETE, AUTH_LOGIN_ERROR, AUTH_LOGIN_SUCCESS>>} The created `Action`
 */
const authLoginWithUsernameAndPassword = ({ password, username }) => ({ authService, fromPromise }) => {
  const promise = authService.loginWithUsernameAndPassword({ password, username });
  return fromPromise(promise, {}, [AUTH_LOGIN, AUTH_LOGIN_COMPLETE, AUTH_LOGIN_ERROR, AUTH_LOGIN_SUCCESS]);
};

export default authLoginWithUsernameAndPassword;
